'use strict';
// One to One, diseño B (2026-10-30): a la izquierda lo que está por confirmar (o lo que se busca),
// en el centro la semana por horas o el mes, y a la derecha la ficha. Un día se bloquea con el botón
// derecho sobre su columna o su casilla, o con «Bloquear» en su cabecera. Estilos: assets/css/views/one-to-one.css (.otw-*).
const OneToOneView = {
    HOUR_PX: 62,
    WEEK_DAYS: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
    PAGE_SIZE: 20,
    labels: { pending: 'Pendiente de confirmar', confirmed: 'Confirmada', cancelled: 'Cancelada', completed: 'Realizada' },
    tags: { pending: 'Por confirmar', confirmed: 'Confirmada', cancelled: 'Cancelada', completed: 'Realizada' },
    mailLabels: { sent: 'enviado', pending: 'pendiente de envío', processing: 'enviando', retry: 'pendiente de reintento', failed: 'no enviado' },
    mailSimulation: false, mode: 'week', month: '', weekStart: '', week: [], days: [], queue: [], queueTotal: 0, results: [], total: 0, page: 1,
    status: '', query: '', selected: null, loading: false, epoch: 0, error: '', menu: null, menuBusy: false, menuError: '', cancelArmed: false, timer: null,

    esc(value) { return Utils.sanitizeHTML(String(value ?? '')); },
    canManage() { return ['admin', 'coordinator'].includes(AuthManager.currentUser?.role) || AuthManager.hasModule('leads', 'manage'); },
    date(value) { return new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', weekday: 'short', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(value)); },
    short(value) { return new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(value)); },
    wall(value) {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(value)).map(p => [p.type, p.value]));
        return { date: `${parts.year}-${parts.month}-${parts.day}`, time: `${parts.hour}:${parts.minute}` };
    },
    addDays(key, days) { const d = new Date(key + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + days); return d.toISOString().slice(0, 10); },
    monday(key) { return this.addDays(key, -((new Date(key + 'T12:00:00Z').getUTCDay() + 6) % 7)); },
    dayLabel(key, options) { return new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC', ...options }).format(new Date(key + 'T12:00:00Z')); },
    today() { return this.wall(new Date()).date; },
    minutes(time) { const [h, m] = time.split(':').map(Number); return h * 60 + m; },
    block(key) { return this.days.find(d => d.date === key && d.blocked) || null; },
    visitsOn(key) { return this.week.filter(v => this.wall(v.startAt).date === key); },
    filtering() { return !!(this.status || this.query); },
    allVisits() { return [...this.week, ...this.queue, ...this.results]; },
    current() { return this.allVisits().find(v => v.id === this.selected) || null; },

    render() {
        if (!this.weekStart) this.setAnchor(this.today());
        const options = Object.entries(this.labels).map(([key, label]) => `<option value="${key}" ${this.status === key ? 'selected' : ''}>${label}</option>`).join('');
        return `<div class="view-container dnr-proposal otw-view" style="padding-top: 1rem;">
            <header class="otw-head">
                <h1 class="otw-title">One to One</h1>
                <div class="otw-week-nav">
                    <button type="button" aria-label="Anterior" ${UIEvents.attr('click', () => OneToOneView.goStep(-1))}>‹</button>
                    <span id="otw-week-label" aria-live="polite">${this.esc(this.weekLabel())}</span>
                    <button type="button" aria-label="Siguiente" ${UIEvents.attr('click', () => OneToOneView.goStep(1))}>›</button>
                </div>
                <button type="button" class="otw-btn" ${UIEvents.attr('click', () => OneToOneView.goTo(OneToOneView.today()))}>Hoy</button>
                <div class="otw-mode" role="group" aria-label="Vista">
                    <button type="button" data-mode="week" aria-pressed="${this.mode === 'week'}" ${UIEvents.attr('click', () => OneToOneView.setMode('week'))}>Semana</button>
                    <button type="button" data-mode="month" aria-pressed="${this.mode === 'month'}" ${UIEvents.attr('click', () => OneToOneView.setMode('month'))}>Mes</button>
                </div>
                <input type="date" class="otw-field" id="otw-goto" aria-label="Ir a una fecha" value="${this.gotoValue()}" ${UIEvents.attr('change', event => { if (event.target.value) OneToOneView.goTo(event.target.value); })}>
                <span class="otw-grow"></span>
                <form class="otw-search" ${UIEvents.attr('submit', event => { event.preventDefault(); OneToOneView.query = document.getElementById('otw-query').value.trim(); OneToOneView.page = 1; OneToOneView.load(); })}>
                    <input type="search" class="otw-field" id="otw-query" maxlength="100" aria-label="Buscar por nombre o correo" placeholder="Nombre o correo" data-search-clear="off" value="${this.esc(this.query)}">
                    <button type="submit" class="otw-btn">Buscar</button>
                </form>
                <select class="otw-field" id="otw-status" aria-label="Estado" ${UIEvents.attr('change', event => { OneToOneView.status = event.target.value; OneToOneView.page = 1; OneToOneView.load(); })}><option value="">Por confirmar</option>${options}</select>
                <button type="button" class="otw-btn" ${UIEvents.attr('click', () => OneToOneView.load())}>Actualizar</button>
            </header>
            <div class="otw-body" aria-live="polite"><p class="otw-note">Cargando visitas…</p></div>
            <div id="otw-menu-host"></div>
        </div>`;
    },

    init() {
        this.closeMenu();
        this.load();
        clearInterval(this.timer);
        // Another screen or the public website may have changed the shared agenda.
        this.timer = setInterval(() => {
            if (!document.querySelector('.otw-view')) { clearInterval(this.timer); return; }
            if (document.visibilityState === 'visible') this.refresh();
        }, 30000);
    },

    // Never repaints over what someone is typing or a menu they have open.
    refresh() {
        const detail = document.querySelector('.otw-detail'), v = this.current();
        if (this.menu || this.loading || detail?.contains(document.activeElement)) return;
        const date = document.getElementById('otw-date'), time = document.getElementById('otw-time');
        if (v && date && time) { const wall = this.wall(v.startAt); if (date.value !== wall.date || time.value !== wall.time) return; }
        this.load();
    },

    weekLabel() {
        if (this.mode === 'month') { const label = this.dayLabel(this.month + '-01', { month: 'long', year: 'numeric' }); return label[0].toUpperCase() + label.slice(1); }
        const end = this.addDays(this.weekStart, 6), month = { day: 'numeric', month: 'short' };
        return `${this.dayLabel(this.weekStart, month)} – ${this.dayLabel(end, month)} ${end.slice(0, 4)}`;
    },
    setAnchor(key) { this.weekStart = this.monday(key); this.month = key.slice(0, 7); },
    goStep(direction) {
        if (this.mode === 'week') this.setAnchor(this.addDays(this.weekStart, direction * 7));
        else { const d = new Date(this.month + '-15T12:00:00Z'); d.setUTCMonth(d.getUTCMonth() + direction); this.month = d.toISOString().slice(0, 7); this.weekStart = this.monday(this.month + '-01'); }
        this.load();
    },
    goTo(key) { this.setAnchor(key); this.load(); },
    // Opening a week from the month keeps today's week when today is in that month.
    setMode(mode, key) {
        this.mode = mode;
        if (key) this.setAnchor(key);
        else if (mode === 'week' && this.today().startsWith(this.month)) this.setAnchor(this.today());
        this.load();
    },
    gotoValue() { return this.mode === 'month' ? this.month + '-01' : this.weekStart; },
    // The month grid runs from the Monday of its first week to the Sunday of its last.
    range() {
        if (this.mode === 'week') return { from: this.weekStart, to: this.addDays(this.weekStart, 6) };
        const next = new Date(this.month + '-15T12:00:00Z');
        next.setUTCMonth(next.getUTCMonth() + 1);
        const last = this.addDays(next.toISOString().slice(0, 7) + '-01', -1);
        return { from: this.monday(this.month + '-01'), to: this.addDays(this.monday(last), 6) };
    },

    paint() {
        const root = document.querySelector('.otw-body');
        if (!root || App.currentView !== 'one-to-one') return;
        const label = document.getElementById('otw-week-label'), go = document.getElementById('otw-goto');
        if (label) label.textContent = this.weekLabel();
        if (go) go.value = this.gotoValue();
        for (const b of document.querySelectorAll('.otw-mode button')) b.setAttribute('aria-pressed', String(b.dataset.mode === this.mode));
        SafeHTML.set(root, this.content());
    },

    content() {
        if (this.error) return `<p role="alert" class="oto-error">${this.esc(this.error)}</p>`;
        const v = this.current();
        return `${this.mailSimulation ? '<p class="oto-local-mode">PRUEBA LOCAL · Los correos se simulan. No se envía ningún correo real.</p>' : ''}
            <div class="otw-columns">${this.side()}${this.agenda()}${v ? this.detail(v) : '<article class="otw-card-box otw-detail otw-detail-empty"><p>Elige una visita para ver su ficha.</p></article>'}</div>`;
    },

    side() {
        const filtered = this.filtering(), list = filtered ? this.results : this.queue, total = filtered ? this.total : this.queueTotal;
        const title = filtered ? `Resultados · ${total}` : `Por confirmar · ${total}`;
        const rows = list.map(v => `<button type="button" class="otw-row ${v.id === this.selected ? 'is-selected' : ''}" ${UIEvents.attr('click', (_, c) => OneToOneView.pick(c[0]), [v.id])}>
                <b>${this.esc(v.contact.nombre)}</b>
                <span class="otw-mono">${this.esc(this.short(v.startAt))}</span>
                <span class="otw-small">${filtered ? this.esc(this.tags[v.status]) + ' · ' : ''}${this.esc(filtered ? v.contact.email : (v.contact.interes || 'Orientación'))}</span>
            </button>`).join('');
        const empty = `<p class="otw-note">${filtered ? 'No hay visitas con estos filtros.' : 'Todo confirmado.'}</p>`;
        const pages = Math.max(1, Math.ceil(total / this.PAGE_SIZE));
        const nav = total > this.PAGE_SIZE ? `<nav class="otw-pages" aria-label="Páginas de visitas">
                <button type="button" class="otw-btn" ${this.page <= 1 ? 'disabled' : ''} ${UIEvents.attr('click', () => { OneToOneView.page--; OneToOneView.load(); })}>←</button>
                <span class="otw-mono">${this.page} de ${pages}</span>
                <button type="button" class="otw-btn" ${this.page >= pages ? 'disabled' : ''} ${UIEvents.attr('click', () => { OneToOneView.page++; OneToOneView.load(); })}>→</button>
            </nav>` : '';
        return `<section class="otw-card-box otw-side">
            <header class="otw-side-head ${filtered ? '' : 'is-pending'}"><span class="otw-label">${title}</span></header>
            <div class="otw-side-list">${rows || empty}</div>
            ${nav}
            <p class="otw-side-note">La franja queda bloqueada desde que llega la petición. Al cambiar o cancelar una cita, la anterior vuelve a estar disponible.</p>
        </section>`;
    },

    // Monday to Saturday; Sunday only when something happens on it.
    columns() {
        const keys = Array.from({ length: 7 }, (_, i) => this.addDays(this.weekStart, i));
        return keys.filter((key, i) => i < 6 || this.block(key) || this.visitsOn(key).some(v => v.status !== 'cancelled'));
    },

    monthAgenda() {
        const { from, to } = this.range(), today = this.today(), manage = this.canManage(), cells = [];
        for (let key = from; key <= to; key = this.addDays(key, 1)) {
            const blocked = this.block(key), visits = this.visitsOn(key).filter(v => v.status !== 'cancelled');
            const chips = visits.slice(0, 3).map(v => `<button type="button" class="otw-chip is-${v.status} ${v.id === this.selected ? 'is-selected' : ''}" ${UIEvents.attr('click', (_, c) => OneToOneView.pick(c[0]), [v.id])}><b>${this.esc(this.wall(v.startAt).time)}</b> ${this.esc(v.contact.nombre)}</button>`).join('');
            cells.push(`<div class="otw-cell ${key.startsWith(this.month) ? '' : 'is-other'} ${blocked ? 'is-blocked' : ''} ${key === today ? 'is-today' : ''}" ${manage ? UIEvents.attr('contextmenu', (event, c) => OneToOneView.openMenu(event, c[0]), [key]) : ''}>
                <button type="button" class="otw-cell-day" aria-label="Ver la semana del ${this.esc(this.dayLabel(key, { day: 'numeric', month: 'long' }))}" ${UIEvents.attr('click', (_, c) => OneToOneView.setMode('week', c[0]), [key])}>${Number(key.slice(8))}</button>
                ${chips}
                ${visits.length > 3 ? `<button type="button" class="otw-cell-more" ${UIEvents.attr('click', (_, c) => OneToOneView.setMode('week', c[0]), [key])}>+${visits.length - 3} más</button>` : ''}
                ${blocked ? `<span class="otw-cell-reason">No disponible${blocked.reason ? ' · ' + this.esc(blocked.reason) : ''}</span>` : ''}
            </div>`);
        }
        return `<section class="otw-card-box otw-agenda">
            <div class="otw-agenda-inner">
                <div class="otw-month-head">${this.WEEK_DAYS.map(d => `<span>${d}</span>`).join('')}</div>
                <div class="otw-month">${cells.join('')}</div>
            </div>
            ${manage ? '<p class="otw-agenda-note">Botón derecho sobre un día para bloquearlo. Se aplica al momento en la web y en SICAF. Pulsa el número para ver esa semana.</p>' : ''}
        </section>`;
    },

    agenda() {
        if (this.mode === 'month') return this.monthAgenda();
        const active = this.week.filter(v => v.status !== 'cancelled'), keys = this.columns(), today = this.today(), manage = this.canManage();
        const starts = active.map(v => this.minutes(this.wall(v.startAt).time));
        const first = Math.min(9, ...starts.map(m => Math.floor(m / 60))), last = Math.max(19, ...starts.map(m => Math.ceil((m + 60) / 60)));
        const hours = Array.from({ length: last - first }, (_, i) => first + i);
        const height = hours.length * this.HOUR_PX;
        const heads = keys.map(key => {
            const blocked = this.block(key);
            return `<div class="otw-day-head ${key === today ? 'is-today' : ''}" ${manage ? UIEvents.attr('contextmenu', (event, c) => OneToOneView.openMenu(event, c[0]), [key]) : ''}>
                <b>${this.esc(this.WEEK_DAYS[(new Date(key + 'T12:00:00Z').getUTCDay() + 6) % 7])} ${Number(key.slice(8))}${key === today ? ' · hoy' : ''}</b>
                ${manage ? `<button type="button" class="otw-day-btn ${blocked ? 'is-blocked' : ''}" aria-label="${blocked ? 'Volver a habilitar' : 'Bloquear'} el ${this.esc(this.dayLabel(key, { day: 'numeric', month: 'long' }))}" ${UIEvents.attr('click', (event, c) => OneToOneView.openMenu(event, c[0]), [key])}>${blocked ? 'Habilitar' : 'Bloquear'}</button>` : ''}
            </div>`;
        }).join('');
        const cols = keys.map(key => {
            const blocked = this.block(key);
            const cards = active.filter(v => this.wall(v.startAt).date === key).map(v => {
                const top = (this.minutes(this.wall(v.startAt).time) - first * 60) * this.HOUR_PX / 60;
                return `<button type="button" class="otw-visit is-${v.status} ${v.id === this.selected ? 'is-selected' : ''}" style="top: ${top}px; height: ${this.HOUR_PX - 3}px;" ${UIEvents.attr('click', (_, c) => OneToOneView.pick(c[0]), [v.id])}>
                    <b>${this.esc(v.contact.nombre)}</b><span>${this.esc(this.wall(v.startAt).time)} · ${this.esc(this.tags[v.status])}</span>
                </button>`;
            }).join('');
            return `<div class="otw-day ${blocked ? 'is-blocked' : ''} ${key === today ? 'is-today' : ''}" style="height: ${height}px; background-size: 100% ${this.HOUR_PX}px;" ${manage ? UIEvents.attr('contextmenu', (event, c) => OneToOneView.openMenu(event, c[0]), [key]) : ''}>
                ${blocked ? `<span class="otw-day-reason">No disponible${blocked.reason ? ' · ' + this.esc(blocked.reason) : ''}</span>` : ''}${cards}
            </div>`;
        }).join('');
        const template = `grid-template-columns: 52px repeat(${keys.length}, minmax(0, 1fr));`;
        return `<section class="otw-card-box otw-agenda">
            <div class="otw-agenda-inner">
                <div class="otw-grid otw-grid-head" style="${template}"><span></span>${heads}</div>
                <div class="otw-grid" style="${template}">
                    <div class="otw-hours">${hours.map(h => `<span style="height: ${this.HOUR_PX}px;">${String(h).padStart(2, '0')}:00</span>`).join('')}</div>
                    ${cols}
                </div>
            </div>
            ${manage ? '<p class="otw-agenda-note">Botón derecho sobre un día para bloquearlo. Se aplica al momento en la web y en SICAF.</p>' : ''}
        </section>`;
    },

    detail(v) {
        const p = v.contact, wall = this.wall(v.startAt), notice = v.notices?.[0], closed = ['completed', 'cancelled'].includes(v.status), manage = this.canManage();
        const failed = notice && ['failed', 'retry'].includes(notice.status);
        const guests = `${p.guestCount || 0}${p.guestNames?.length ? ' · ' + p.guestNames.map(x => this.esc(x)).join(', ') : ''}`;
        return `<article class="otw-card-box otw-detail">
            <header class="otw-detail-head">
                <span class="otw-label">Ficha de visita · Hora de Bilbao</span>
                <h2>${this.esc(p.nombre)}</h2>
                <span class="otw-badge is-${v.status}">${this.labels[v.status]}</span>
            </header>
            <dl class="otw-facts">
                <div><dt class="otw-label">Horario actual</dt><dd><b>${this.esc(this.date(v.startAt))} · 1 hora</b></dd></div>
                <div><dt class="otw-label">Petición original</dt><dd>${this.esc(this.date(v.requestedStart))}</dd></div>
                <div><dt class="otw-label">Contacto</dt><dd><a href="mailto:${this.esc(p.email)}">${this.esc(p.email)}</a><br>${this.esc(p.telefono || 'Teléfono no indicado')}</dd></div>
                <div><dt class="otw-label">Formación</dt><dd>${this.esc(p.interes || 'Orientación')}</dd></div>
                <div><dt class="otw-label">Acompañantes</dt><dd>${guests}</dd></div>
            </dl>
            ${p.mensaje ? `<div class="otw-message">${this.esc(p.mensaje)}</div>` : ''}
            ${notice ? `<div class="otw-mail ${failed ? 'is-failed' : ''}"><span>Correo al visitante: <b>${this.esc(this.mailLabels[notice.status] || notice.status)}</b></span>${failed && manage ? `<button type="button" class="otw-btn" ${UIEvents.attr('click', () => OneToOneView.retry())}>Reintentar</button>` : ''}</div>` : ''}
            ${!closed && manage ? `<form id="otw-edit" class="otw-form" ${UIEvents.attr('submit', event => { event.preventDefault(); OneToOneView.save('confirmed'); })}>
                <b>${v.status === 'pending' ? 'Confirmar la visita' : 'Cambiar el horario'}</b>
                <div class="otw-datetime">
                    <input id="otw-date" class="otw-field" type="date" aria-label="Día" value="${wall.date}" required>
                    <input id="otw-time" class="otw-field" type="time" aria-label="Hora de Bilbao" value="${wall.time}" required>
                </div>
                <button class="otw-primary" type="submit">${v.status === 'pending' ? 'Confirmar visita' : 'Confirmar nuevo horario'}</button>
                <span class="otw-small">Se bloqueará esta hora y se enviará un correo al visitante.</span>
                <div class="otw-actions">
                    ${v.status === 'confirmed' ? `<button class="otw-btn" type="button" ${UIEvents.attr('click', () => OneToOneView.save('completed'))}>Marcar realizada</button>` : ''}
                    ${this.cancelArmed ? `<button class="otw-btn is-danger-on" type="button" ${UIEvents.attr('click', () => OneToOneView.save('cancelled'))}>Sí, cancelar y avisar</button><button class="otw-btn" type="button" ${UIEvents.attr('click', () => { OneToOneView.cancelArmed = false; OneToOneView.paint(); })}>No</button>` : `<button class="otw-btn is-danger" type="button" ${UIEvents.attr('click', () => { OneToOneView.cancelArmed = true; OneToOneView.paint(); })}>Cancelar visita</button>`}
                </div>
                <p id="otw-save-result" role="status" class="otw-small"></p>
            </form>` : ''}
            ${closed ? '<p class="otw-closed">Esta visita está cerrada y ya no se puede cambiar.</p>' : ''}
        </article>`;
    },

    pick(id) {
        const v = this.allVisits().find(x => x.id === id);
        if (!v) return;
        this.selected = id;
        this.cancelArmed = false;
        const key = this.wall(v.startAt).date;
        if (this.mode === 'week' ? this.monday(key) !== this.weekStart : !key.startsWith(this.month)) { this.goTo(key); return; }
        this.paint();
    },

    async read(url) {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        const result = await response.json();
        if (!response.ok || !result.success) throw Error(result.error || 'No se pueden cargar las visitas.');
        return result;
    },

    async load() {
        if (!this.weekStart) return;
        const epoch = ++this.epoch, authEpoch = AuthManager._epoch, { from, to } = this.range();
        this.loading = true;
        this.error = '';
        try {
            const [week, days, queue, found] = await Promise.all([
                this.read('/api/one-to-one?' + new URLSearchParams({ from, to })),
                this.read('/api/one-to-one/day-blocks?' + new URLSearchParams({ from, to })),
                this.read('/api/one-to-one?' + new URLSearchParams({ status: 'pending', sort: 'start' })),
                this.filtering() ? this.read('/api/one-to-one?' + new URLSearchParams({ page: this.page, status: this.status, q: this.query, sort: 'start' })) : null
            ]);
            if (epoch !== this.epoch || authEpoch !== AuthManager._epoch) return;
            this.week = week.items;
            this.days = days.days;
            this.queue = queue.items;
            this.queueTotal = queue.total;
            this.results = found?.items || [];
            this.total = found?.total || 0;
            this.mailSimulation = week.mailSimulation === true;
            if (!this.current()) this.selected = (this.filtering() ? this.results[0] : this.queue[0])?.id || this.week.find(v => v.status !== 'cancelled')?.id || null;
        } catch (e) {
            if (epoch === this.epoch) this.error = e.message;
        } finally {
            if (epoch === this.epoch) { this.loading = false; this.paint(); }
        }
    },

    async save(status) {
        const v = this.current();
        if (!v) return;
        const form = document.getElementById('otw-edit'), result = document.getElementById('otw-save-result');
        if (status === 'confirmed' && !form.reportValidity()) return;
        const date = document.getElementById('otw-date').value, time = document.getElementById('otw-time').value;
        for (const b of form.querySelectorAll('button')) b.disabled = true;
        try {
            const response = await fetch('/api/one-to-one/' + encodeURIComponent(v.id), { method: 'PATCH', headers: { 'Content-Type': 'application/json', 'X-SICAF-CSRF': AuthManager.getCsrfToken() }, body: JSON.stringify({ status, version: v.version, date, time }) });
            const data = await response.json();
            if (!response.ok || !data.success) throw Error(data.error || 'No se pudo guardar.');
            this.cancelArmed = false;
            if (status === 'confirmed') this.setAnchor(date);
            await this.load();
            Utils.showToast('Visita actualizada. La disponibilidad de la web ya está actualizada.', 'success');
        } catch (e) {
            result.textContent = e.message;
            result.className = 'oto-error';
            for (const b of form.querySelectorAll('button')) b.disabled = false;
        }
    },

    async retry() {
        try {
            const r = await fetch('/api/one-to-one/' + encodeURIComponent(this.selected) + '/retry-mail', { method: 'POST', headers: { 'X-SICAF-CSRF': AuthManager.getCsrfToken() } });
            const data = await r.json();
            if (!r.ok) throw Error(data.error);
            await this.load();
        } catch (e) { Utils.showToast(e.message, 'error'); }
    },

    // Same menu for the right click on a day and for its «Bloquear» button (keyboard and touch).
    openMenu(event, key) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.canManage()) return;
        this.menu = { key, x: event.clientX, y: event.clientY };
        this.menuError = '';
        this.paintMenu();
        const input = document.getElementById('otw-menu-reason');
        input?.focus();
    },

    paintMenu() {
        const host = document.getElementById('otw-menu-host');
        if (!host) return;
        if (!this.menu) { SafeHTML.set(host, ''); return; }
        const { key } = this.menu, blocked = this.block(key), planned = this.visitsOn(key).filter(v => ['pending', 'confirmed'].includes(v.status)).length;
        SafeHTML.set(host, `<div id="otw-menu" class="otw-menu" role="dialog" aria-label="Disponibilidad del día" ${UIEvents.attr('keydown', event => { if (event.key === 'Escape') OneToOneView.closeMenu(); })}>
            <b class="otw-menu-title">${this.esc(this.dayLabel(key, { weekday: 'long', day: 'numeric', month: 'long' }))}</b>
            <span class="otw-small">${blocked ? 'Día bloqueado para nuevas citas.' : 'Día disponible para nuevas citas.'}</span>
            ${blocked ? (blocked.reason ? `<span class="otw-menu-reason">${this.esc(blocked.reason)}</span>` : '') : `<label class="otw-menu-field"><span class="otw-label">Motivo (opcional)</span><input id="otw-menu-reason" class="otw-field" maxlength="200"></label>`}
            ${!blocked && planned ? `<span class="otw-menu-warn">Ya hay ${planned} ${planned === 1 ? 'visita prevista' : 'visitas previstas'} este día. No se cancelan: tendrás que revisarlas.</span>` : ''}
            ${this.menuError ? `<span class="oto-error" role="alert">${this.esc(this.menuError)}</span>` : ''}
            <button type="button" class="${blocked ? 'otw-btn' : 'otw-menu-block'}" ${this.menuBusy ? 'disabled' : ''} ${UIEvents.attr('click', () => OneToOneView.toggleDay())}>${this.menuBusy ? 'Guardando…' : blocked ? 'Volver a habilitar este día' : 'Bloquear este día'}</button>
        </div>`);
        const box = document.getElementById('otw-menu');
        if (!box) return;
        const left = Math.max(8, Math.min(this.menu.x, window.innerWidth - box.offsetWidth - 8)), top = Math.max(8, Math.min(this.menu.y, window.innerHeight - box.offsetHeight - 8));
        box.style.left = left + 'px';
        box.style.top = top + 'px';
        if (!this._menuListener) {
            this._menuListener = e => { if (OneToOneView.menu && !e.target.closest?.('#otw-menu')) OneToOneView.closeMenu(); };
            document.addEventListener('mousedown', this._menuListener);
        }
    },

    closeMenu() {
        this.menu = null;
        this.menuError = '';
        this.paintMenu();
    },

    async toggleDay() {
        if (!this.menu || this.menuBusy) return;
        const { key } = this.menu, row = this.days.find(d => d.date === key), blocked = row?.blocked === true;
        const reason = blocked ? '' : (document.getElementById('otw-menu-reason')?.value || '');
        this.menuBusy = true;
        this.paintMenu();
        try {
            const response = await fetch('/api/one-to-one/day-blocks', { method: 'PUT', headers: { 'Content-Type': 'application/json', 'X-SICAF-CSRF': AuthManager.getCsrfToken() }, body: JSON.stringify({ date: key, blocked: !blocked, reason, version: row?.version || 0 }) });
            const data = await response.json();
            if (!response.ok || !data.success) throw Error(data.error || 'No se pudo guardar.');
            this.days = [...this.days.filter(d => d.date !== data.day.date), data.day];
            this.menuBusy = false;
            this.closeMenu();
            this.paint();
            Utils.showToast((data.day.blocked ? 'Día bloqueado' : 'Día habilitado') + ' en la web y en SICAF.' + (data.affectedVisits ? ` Hay ${data.affectedVisits} visita(s) ya previstas: revísalas, no se han cancelado.` : ''), data.affectedVisits ? 'warning' : 'success');
        } catch (e) {
            this.menuBusy = false;
            this.menuError = e.message;
            this.paintMenu();
        }
    }
};
